// import "../css/adminDashboard.css";
// // import "../css/AdminForms.css";
// import AdminLayout from "../components/AdminLayout";
// import AdminContent from "./AdminContent";

// const AdminDashboard = () => {
//   return (
//     <>
//       <AdminLayout />
//     </>
//   );
// };

// export default AdminDashboard;


import React from "react";
import "../css/adminDashboard.css"; // ← lowercase 'a' — matches actual file on disk
import AdminLayout from "../components/AdminLayout";

// Error boundary catches any crash and shows it on screen
class DashboardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error("=== ADMIN DASHBOARD CRASH ===");
    console.error("Error:", error);
    console.error("Stack:", info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: "2rem", fontFamily: "monospace",
          background: "#fff", minHeight: "100vh", color: "#c0392b",
        }}>
          <h2>⚠️ Dashboard Crash</h2>
          <pre style={{
            background: "#fff5f5", border: "1px solid #f5c6c6",
            borderRadius: "8px", padding: "1rem", fontSize: "0.8rem",
            whiteSpace: "pre-wrap", wordBreak: "break-all",
          }}>
            {this.state.error?.toString()}
            {"\n\n"}
            {this.state.info?.componentStack}
          </pre>
          <button
            style={{
              marginTop: "1rem", padding: "0.5rem 1.5rem",
              background: "#162f06", color: "#fff",
              border: "none", borderRadius: "8px", cursor: "pointer",
            }}
            onClick={() => window.location.href = "/admin"}
          >
            ← Back to Login
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const AdminDashboard = () => (
  <DashboardErrorBoundary>
    <AdminLayout />
  </DashboardErrorBoundary>
);

export default AdminDashboard;